import colors from './colors';

const typography = {
    useNextVariants: true,
    htmlFontSize: 16,
    fontSize: 16,

    body1: {
        fontFamily: 'DM Sans',
        fontStyle: 'normal',
        fontWeight: 'bold',
        fontSize: '1rem',
        lineHeight: '1.5em',
        letterSpacing: '0.0018rem',
        color: colors.primary,
        mixBlendMode: 'normal',
    },

    body2: {
        fontFamily: 'DM Sans',
        fontStyle: 'normal',
        fontWeight: 'bold',
        fontSize: '1.25rem',
        lineHeight: '1.5em',
        letterSpacing: '0.0042rem',
        color: colors.secondary,
        mixBlendMode: 'normal',
    },

    body3: {
        fontFamily: 'DM Sans',
        fontStyle: 'normal',
        fontWeight: 'bold',
        fontSize: '1.25rem',
        lineHeight: '1.5em',
        color: 'black',
        mixBlendMode: 'normal',
    },

    body4: {
        fontFamily: 'DM Sans',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: '1rem',
        lineHeight: '1.5em',
        color: 'black',
        mixBlendMode: 'normal',
    },

    body5: {
        fontFamily: 'DM Sans',
        fontStyle: 'normal',
        fontWeight: 'bold',
        fontSize: '1rem',
        lineHeight: '1.5em',
        color: colors.primary,
        mixBlendMode: 'normal',
    },

    header1: {
        fontFamily: 'DM Sans',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: '1.25rem',
        lineHeight: '1.5em',
        letterSpacing: '0.0042rem',
        color: 'black',
        mixBlendMode: 'normal',
    },
    header2: {
        fontFamily: 'DM Sans',
        fontStyle: 'normal',
        fontWeight: 'bold',
        fontSize: '1.6rem',
        lineHeight: '1.5em',
        letterSpacing: '0.0018rem',
        color: colors.primaryLight,
    },
    header3: {
        fontFamily: 'DM Sans',
        fontStyle: 'normal',
        fontWeight: 'bold',
        fontSize: '1.25rem',
        lineHeight: '1.5em',
        letterSpacing: '0.0018rem',
        color: colors.primaryLight,
    },
    header4: {
        fontFamily: 'DM Sans',
        fontStyle: 'normal',
        fontWeight: 'bold',
        fontSize: '1rem',
        lineHeight: '1.5em',
        letterSpacing: '0.0018rem',
        color: colors.primaryLight,
    },

    title1: {
        fontFamily: 'DM Sans',
        fontStyle: 'normal',
        fontWeight: 'bold',
        fontSize: '3rem',
        lineHeight: '1.5em',
        letterSpacing: '0.0042rem',
        color: colors.primary,
        mixBlendMode: 'normal',
    },

    title2: {
        fontFamily: 'DM Sans',
        fontStyle: 'normal',
        fontWeight: 'bold',
        fontSize: '2.25rem',
        lineHeight: '1.5em',
        letterSpacing: '0.0033rem',
        color: colors.primary,
        mixBlendMode: 'normal',
    },

    title3: {
        fontFamily: 'DM Sans',
        fontStyle: 'normal',
        fontWeight: 'bold',
        fontSize: '2rem',
        lineHeight: '1.5em',
        letterSpacing: '0.0033rem',
        color: colors.primary,
        mixBlendMode: 'normal',
    },

    title4: {
        fontFamily: 'DM Sans',
        fontStyle: 'normal',
        fontWeight: 'bold',
        fontSize: '1.55rem',
        lineHeight: '1.5em',
        letterSpacing: '0.0033rem',
        color: colors.primary,
        mixBlendMode: 'normal',
    },

    label1: {
        fontFamily: 'DM Sans',
        fontStyle: 'normal',
        fontWeight: 'bold',
        fontSize: '1rem',
        lineHeight: '1.5em',
        letterSpacing: '0.0014rem',
        color: colors.secondary,
        mixBlendMode: 'normal',
    },
};

export default typography;
